import bandeiraBrasil from '../../../../assets/bandeiras/br.svg';
import bandeiraEspanha from '../../../../assets/bandeiras/es.svg';
import bandeiraEUA from '../../../../assets/bandeiras/us.svg';
import styles from './index.module.scss';

const OPCOES_IDIOMA = [
    {
        idioma: 'pt_BR',
        bandeira: bandeiraBrasil,
        bandeiraAlt: 'Bandeira Brasil'
    },
    {
        idioma: 'es_ES',
        bandeira: bandeiraEspanha,
        bandeiraAlt: 'Bandeira Espanha'
    },
    {
        idioma: 'en_US',
        bandeira: bandeiraEUA,
        bandeiraAlt: 'Bandeira EUA'
    }
]

export default function OpcoesIdioma({
    tamanhoBandeira=32,
    idiomaAtual='pt_BR',
    idiomaPressionado,
    classeContainer=''
}) {
    return (
        <div className={`${styles.containerBandeiras} ${classeContainer}`}>
            {OPCOES_IDIOMA.map((opcao, index) => {
                const idiomaSelecionado = idiomaAtual === opcao.idioma;

                return (
                    <button
                        key={`${opcao.idioma}_${index}`}
                        onClick={() => idiomaPressionado(opcao.idioma)}
                        className={`
                            ${styles.botaoBandeira}
                            ${' '}
                            ${
                                idiomaSelecionado
                                    ? styles.botaoIdiomaAtual
                                    : ''
                            }
                        `}
                    >
                        <img 
                            src={opcao.bandeira} 
                            alt={opcao.bandeiraAlt}
                            width={tamanhoBandeira} 
                            height={'auto'}
                            className={idiomaSelecionado ? styles.imagemIdiomaAtual : ''}
                        />
                    </button>    
                )
            })}
        </div>
    )
}